// Icone vettoriali locali: nessuna dipendenza, richiesta esterna o font da caricare.
const paths = {
  home: 'm3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1Z',
  mic: 'M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3ZM5 10v2a7 7 0 0 0 14 0v-2M12 19v3M8 22h8',
  archive: 'M4 8h16v13H4ZM3 3h18v5H3ZM9 12h6',
  photos: 'M4 3h16v18H4ZM4 16l5-5 4 4 3-3 4 4M15 7h.01',
  family: 'M16 21v-3a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v3M9.5 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM17 4a4 4 0 0 1 0 7M21 21v-3a4 4 0 0 0-3-3.87',
  book: 'M12 5C8 2 4 3 2 4v16c4-2 7-1 10 1 3-2 6-3 10-1V4c-2-1-6-2-10 1ZM12 5v16',
  clock: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM12 6v6l4 2',
  messages: 'M21 11a8 8 0 0 1-8 8H7l-5 3 1.5-6A8 8 0 0 1 3 5a8 8 0 0 1 10-2 8 8 0 0 1 8 8ZM7 10h10M7 14h6',
  help: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM9 9a3 3 0 0 1 6 0c0 2-3 2-3 5M12 17h.01',
  chat: 'M4 5h16v11H9l-5 4ZM8 9h8M8 12h5',
  menu: 'M4 6h16M4 12h16M4 18h16',
  search: 'M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14ZM15 15l6 6',
  tree: 'M9 2h6v5H9ZM2 17h6v5H2ZM16 17h6v5h-6ZM12 7v5M5 17v-5h14v5',
  recipe: 'M8 3v5M4 3v5a4 4 0 0 0 8 0V3M8 12v10M20 22V3c-4 3-4 9 0 10',
  check: 'm5 12 4 4L19 6',
  heart: 'M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z',
  arrow: 'M4 12h16m-6-6 6 6-6 6',
  settings: 'M4 6h16M4 12h16M4 18h16M8 3v6M16 9v6M10 15v6',
  plus: 'M12 4v16M4 12h16',
  envelope: 'M3 5h18v14H3ZM3 5l9 8 9-8M3 19l6-7M21 19l-6-7',
  bookmark: 'M6 3h12v19l-6-4-6 4Z',
  leaf: 'M20 3C8 2 2 8 5 15c6 5 15-1 15-12ZM4 21l11-13',
  cup: 'M3 8h13v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4ZM16 9h3a3 3 0 0 1 0 6h-3M2 22h17M6 2v2M11 2v2',
} as const;

export type IconName = keyof typeof paths;
export function icon(name: IconName, className = ''): SVGSVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  for (const [key, value] of Object.entries({ viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.7', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false', class: `ui-icon ${className}` })) svg.setAttribute(key, value);
  const path = document.createElementNS(svg.namespaceURI, 'path');
  path.setAttribute('d', paths[name]);
  svg.append(path);
  return svg;
}
